import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { makeSessionJsonStorage, withPrefix } from "./storage";

// global state for selected stop IDs (ordered)
export const selectedStopIdsAtom = atom<string[]>([]);

// active stop ID per tab (sessionStorage) to avoid cross-tab flicker
export const activeStopIdAtom = atomWithStorage<string | null>(
  withPrefix("active-stop-id"),
  null,
  makeSessionJsonStorage<string | null>()
);

// add stop-id at front, removing duplicates
export const addStopIdAtom = atom(null, (get, set, id: string) => {
  const cur = get(selectedStopIdsAtom);
  const next = [id, ...cur.filter((x) => x !== id)];
  set(selectedStopIdsAtom, next);
});

//add multiple stop-ids at end, preserving order and avoiding duplicates
export const addStopIdsAtom = atom(null, (get, set, ids: string[]) => {
  const cur = get(selectedStopIdsAtom);
  const curSet = new Set(cur);
  const appended = ids.filter((id) => !curSet.has(id));
  set(selectedStopIdsAtom, [...cur, ...appended]);
});

// remove a stop; reset active if it was the same
export const removeStopIdAtom = atom(null, (get, set, id: string) => {
  const cur = get(selectedStopIdsAtom);
  set(
    selectedStopIdsAtom,
    cur.filter((x) => x !== id)
  );
  if (get(activeStopIdAtom) === id) set(activeStopIdAtom, null);
});

// clear all selected stops and active stop
export const clearStopsAtom = atom(null, (_get, set) => {
  set(selectedStopIdsAtom, []);
  set(activeStopIdAtom, null);
});
